import React from "react";
import styled from "styled-components";
import {Cell} from "./Cell";
import {Price} from "../../../../contribute/idea/Price";

export const pricesWidth = 80;

const Container = styled(Cell)`
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    flex-basis: ${pricesWidth + "px"};
    margin-right: 0px;
`;

const PriceLabel = styled.div`
    margin-right: 8px;
    font-size: 10px;
`;


function label(portfolioIdea) {
    if (portfolioIdea.startPrice === null) {
        return null;
    }
    return portfolioIdea.priceLabel === "TOUCH" ? "Touch" : portfolioIdea.priceLabel;
}

export const PricesCell = ({className, portfolioIdea}) => {
    if (portfolioIdea.kpiValue === null && portfolioIdea.priceLabel !== "Period Start") {
        return <Container className={className}>
            <Price price={null}/>
        </Container>
    }
    return <Container className={className}>
        <Price price={portfolioIdea.startPrice} currency={portfolioIdea.stockCurrency}/>
        <PriceLabel>{label(portfolioIdea)}</PriceLabel>
    </Container>
};

const Header = styled(Container)`
    margin-right: 12px;
    font-size: 11px;
    font-weight: bold;
`;

export const PriceHeader = () => {
    return <Header className="t-price-heading">Start Price</Header>
};